import RubricatorSelector from "./rubricator-selector";

export default RubricatorSelector;
